"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TellimerGraphqlClient: function() {
        return _graphqlClient.TellimerGraphqlClient;
    },
    TellimerWebSocketClient: function() {
        return _graphqlWebsocketClient.TellimerWebSocketClient;
    },
    gql: function() {
        return _core.gql;
    },
    Client: function() {
        return _urql.Client;
    },
    TypedDocumentNode: function() {
        return _urql.TypedDocumentNode;
    }
});
var _graphqlClient = require("./graphql-client");
var _graphqlWebsocketClient = require("./graphql-websocket-client");
var _core = require("@urql/core");
var _urql = require("urql");

//# sourceMappingURL=index.js.map